// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 13 hooks for backend/loans.

import { useBackend } from '../useBackend'

/** POST /api/loans/cancelLoan */
export function useCancelLoan<T = any>() {
  return useBackend<T>('loans/cancelLoan')
}

/** POST /api/loans/checkLoanSignatures */
export function useCheckLoanSignatures<T = any>() {
  return useBackend<T>('loans/checkLoanSignatures')
}

/** POST /api/loans/createLoan */
export function useCreateLoan<T = any>() {
  return useBackend<T>('loans/createLoan')
}

/** POST /api/loans/getLoanDocumentLink */
export function useGetLoanDocumentLink<T = any>() {
  return useBackend<T>('loans/getLoanDocumentLink')
}

/** POST /api/loans/getLoanOptions */
export function useGetLoanOptions<T = any>() {
  return useBackend<T>('loans/getLoanOptions')
}

/** POST /api/loans/getLoanPreview */
export function useGetLoanPreview<T = any>() {
  return useBackend<T>('loans/getLoanPreview')
}

/** POST /api/loans/getLoanProofUrl */
export function useGetLoanProofUrl<T = any>() {
  return useBackend<T>('loans/getLoanProofUrl')
}

/** POST /api/loans/getLoans */
export function useGetLoans<T = any>() {
  return useBackend<T>('loans/getLoans')
}

/** POST /api/loans/getLoansAccess */
export function useGetLoansAccess<T = any>() {
  return useBackend<T>('loans/getLoansAccess')
}

/** POST /api/loans/getLoansDue */
export function useGetLoansDue<T = any>() {
  return useBackend<T>('loans/getLoansDue')
}

/** POST /api/loans/markLoanPaidOut */
export function useMarkLoanPaidOut<T = any>() {
  return useBackend<T>('loans/markLoanPaidOut')
}

/** POST /api/loans/recordLoanDeduction */
export function useRecordLoanDeduction<T = any>() {
  return useBackend<T>('loans/recordLoanDeduction')
}

/** POST /api/loans/resendLoan */
export function useResendLoan<T = any>() {
  return useBackend<T>('loans/resendLoan')
}
